<template>
    <div class="main-preloader">
        <div class="spinner">
            <div class="spinner-icon"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'preloader'
    };
</script>

<style lang="scss">
    @import './preloader.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/preloader/preloader.vue